import { MainPage } from '@/components';
import { SideNav } from '@/modules/AspynMigrator/components';
import { Outlet } from 'react-router-dom';

const AspynMigrator = () => (
  <MainPage sideNav={<SideNav />}>
    <Outlet />
  </MainPage>
);

export default AspynMigrator;
